import {
    useCallback,
    useMemo,
} from 'react'
import PropTypes from 'prop-types'

import SkyNetTable from 'app/shared-components/SkyNetTable'

import useLoggerRoutes from 'app/SkyNetRoutes/hooks/useLoggerRoutes'
import requests from 'app/requests/Logger.requests'
import config from './ConnectedLoggers.config'

type ConnectedLoggersFilter = {
    gatewayGatewayId: number[]
}

type ConnectedLoggersRowClick = ({
    loggerNumber: number,
}) => void

const propTypes = {
    value: PropTypes.string.isRequired,
}

const defaultProps = {}

const ConnectedLoggers = ({
    value,
}) => {
    const {
        Loggers: LoggerRoutes,
    } = useLoggerRoutes()

    const filters: ConnectedLoggersFilter = useMemo(() => {
        return {
            gatewayGatewayId: [value],
        }
    }, [value])

    const onRowClickLogger: ConnectedLoggersRowClick = useCallback(({
        loggerNumber,
    }) => {
        LoggerRoutes.Overview.navigate({
            params: {
                key: loggerNumber,
            },
        })
    }, [LoggerRoutes.Overview])

    return (
        <SkyNetTable
            name="Logger"
            filter={filters}
            simple
            uniqField="loggerNumber"
            onRowClick={onRowClickLogger}
            customUrl={requests.filterRequestAll().url}
            tableConfig={{
                ...config,
                tabs: [],
            }}
        />
    )
}

ConnectedLoggers.propTypes = propTypes
ConnectedLoggers.defaultProps = defaultProps

export default ConnectedLoggers
